// Shared by React routes and Express SEO lookup.
const PATH = {
	AUTO_RENEW_AGREEMENT: '#auto-renew',
	ACCOUNT: '/account',
	AGREEMENTS: '/agreements',
	APPLY: '/apply',
	AUTO_RENEW_ENROLLMENT: '/auto-renew-enrollment',
	AUTHORIZATION: '/authorization',
	AUTHORIZE: '/authorize',
	BILLING: '/billing',
	BLOG: '/blog',
	BLOG_ID: '/:blogID',
	BOATS: '/boats',
	CLIENT_ERROR: '/error/client-error',
	CODE: '/code',
	CONFIRM_AND_LOGIN: '/confirm-and-login',
	CONFIRM_GIFT: '/confirm-gift',
	CONFIRM_OFFER: '/confirm-offer',
	CONTACT: '/contact',
	CONTACT_2: '/contact-2',
	COOKIE: '/cookie',
	CREATE_ACCOUNT: '/create-account',
	DEAL: '/deal',
	EDIT: '/edit',
	EDIT_BOAT: '/edit-boat',
	EDIT_OFFER: '/edit-offer',
	EDIT_OTHER_BOAT: '/edit-other-boat',
	ERROR: '/error',
	EXCHANGE: '/exchange',
	EXISTING_MEMBER: '/existing-member',
	EXPIRED: '/expired',
	GATED_CONTENT: '/gated-content',
	HOME_PORT_TYPE: '/home-port-type',
	HOME_PORT_ADDRESS: '/home-port-address',
	HOME_PORT_LOCATION: '/home-port-location',
	LOGIN: '/login',
	LOGOUT: '/logout',
	MEDIA: '/media',
	MEMBER_APPLICATION: '/join',
	MEMBER_PORTAL: '/members',
	MEMBERSHIP_AGREEMENT: '/membership-agreement',
	MEMBERSHIP_CARD: '/membership-card',
	MEMBERSHIP_CARD_VIEW_PRINT: '/membership-card-view-print',
	MEMBERSHIP_KIT: '/membership-kit',
	MEMBERSHIP_TYPE_ALL: '/membership-type-all',
	MEMBERSHIP_TYPE_SELECTED: '/membership-type-selected',
	MEMBERSHIP_TRIAL_SELECTED: '/membership-trial-selected',
	MEMBERSHIP: '/membership',
	MEMBERSHIPS: '/memberships',
	MOBILE_APP: '/mobile-app',
	NEW: '/new',
	NEW_CONTACT: '/new-contact',
	NEW_MEMBER: '/new-member',
	NEW_MEMBER_QUESTIONNAIRE: '/new-member-questionnaire',
	OFFERS: '/offers',
	OTHER: '/other',
	PARTNER_AGREEMENT: '#partner-agreement',
	PROGRAMS_DASHBOARD: '/dashboard',
	PROGRAMS_PORTAL: '/programs',
	PAYMENT: '/payment',
	POST_LOGIN: '/post-login',
	RECIPIENT: '/recipient',
	REFERRALS: '/referrals',
	REGISTRATION: '/registration',
	RENEW_MEMBERSHIP: '/renew',
	RENEWAL_QUESTIONNAIRE: '/renewal-questionnaire',
	REVIEW_ORDER: '/review-order',
	ROOT: '/',
	SAVINGS_CLUB: '/savings-club',
	SAVINGS_CLUB_OFFERS: '/savings-club-offers',
	SEA_CARE: '/sea-care',
	SELECTION: '/selection',
	SEATOW: process.env.REACT_APP_MARKETING_SITE ?? 'https://seatow.com',
	SEATOW_LOGOUT: '/logged-out',
	SEA_TOW_AS_A_GIFT: '/gift',
	SESSION: '/session',
	SELECT_YOUR_MEMBERSHIP: '/select-your-membership',
	SERVER_ERROR: '/error/server-error',
	SIGNUP: '/signup',
	SFID: '/:sfid',
	STEPS: '/steps',
	STYLEGUIDE: '/styleguide',
	TERMS_AND_CONDITIONS: '/terms-and-conditions',
	THANK_YOU: '/thank-you',
	TRAILER_CARE: '/trailer-care',
	TRAILER_CARE_AGREEMENT: '#trailer-care',
	UPGRADES: '/upgrades',
	VIDEO_ID: '/:videoID',
	VIDEOS: '/videos',
}

const makePath = (...args) => args.join('')
const makeGiftPath = (...args) =>
	makeMemberPortalPath(PATH.SEA_TOW_AS_A_GIFT, ...args)
const makeGiftStepsPath = (...args) => makeGiftPath(PATH.STEPS, ...args)
const makeLoginPath = (...args) => makePath(PATH.LOGIN, ...args)
const makeMemberApplicationPath = (...args) =>
	makeMemberPortalPath(PATH.MEMBER_APPLICATION, ...args)
const makeMemberApplicationApplyPath = (...args) =>
	makeMemberApplicationPath(PATH.APPLY, ...args)
const makeMemberPortalPath = (...args) => makePath(PATH.MEMBER_PORTAL, ...args)
const makeMembershipsPath = (...args) =>
	makeMemberPortalPath(PATH.MEMBERSHIPS, ...args)
const makeMembershipIdPath = (...args) => makeMembershipsPath('/', ...args)
const makeMobileAppPath = (...args) => makePath(PATH.MOBILE_APP, ...args)
const makeProgramsPortalPath = (...args) =>
	makePath(PATH.PROGRAMS_PORTAL, ...args)
const makeProgramsApplicationPath = (...args) =>
	makeProgramsPortalPath(PATH.APPLY, ...args)
const makeMarketingSitePath = (...args) => makePath(PATH.SEATOW, ...args)

module.exports = {
	PATH,
	makePath,
	makeGiftPath,
	makeGiftStepsPath,
	makeLoginPath,
	makeMemberApplicationPath,
	makeMemberApplicationApplyPath,
	makeMemberPortalPath,
	makeMembershipsPath,
	makeMembershipIdPath,
	makeMobileAppPath,
	makeProgramsPortalPath,
	makeProgramsApplicationPath,
	makeMarketingSitePath,
}
